import React from 'react';
import StepBar from '@splunk/react-ui/StepBar';
import { _ } from '@splunk/ui-utils/i18n';

type ExportStepBarProps = Pick<
    React.ComponentProps<typeof StepBar>,
    'activeStepId'
>;

export const ExportStepBar = ({ activeStepId }: ExportStepBarProps) => (
    <StepBar activeStepId={activeStepId}>
        <StepBar.Step>{_('Configure')}</StepBar.Step>
        <StepBar.Step>{_('Running all searches')}</StepBar.Step>
        <StepBar.Step>{_('Downloading')}</StepBar.Step>
    </StepBar>
);
